import { defu } from 'defu'
import { defineNuxtPlugin } from '#app'
import { createError, useCoreConfig, useDayjs } from '#imports'

const LOCALES = {
    da: () => import('dayjs/locale/da'),
    en: () => import('dayjs/locale/en')
}

export default defineNuxtPlugin({
    name: 'dayjs',
    order: -100,
    async setup() {
        const { dayjs: config } = useCoreConfig()

        if (!config?.locale?.name) {
            throw createError(new Error('core.dayjs.locale must be set!'))
        }

        if (!(config.locale.name in LOCALES)) {
            throw createError(new Error(`${config.locale.name} is not a valid locale. Please select one of: ${Object.keys(LOCALES).join(', ')}`))
        }

        const dayjs = useDayjs()

        dayjs.tz.setDefault(config?.defaultTimezone)

        const locale = await LOCALES[config.locale.name as keyof typeof LOCALES]()

        dayjs.updateLocale(
            config.locale.name,
            defu(config.locale, locale['default'])
            // config.locale
        )

        dayjs.locale(config.locale.name)
    }
})
